import { IReward } from "api/types";
import * as React from "react";
import { Col, Row } from "react-grid-system";
import { sortRewards } from "screens/RedeemRewards/utils";
import CartReward from "../ChooseRewards/Cart/CartReward";

interface IProps {
  className?: string;
  rewards: IReward[];
  tenantId?: string;
  locationId?: string;
  imageBaseUrl?: string;
  transparentBackground?: boolean;
}

const RewardsList = ({
  rewards,
  className,
  tenantId,
  locationId,
  imageBaseUrl,
  transparentBackground
}: IProps) => (
  <Row className={className}>
    <Col style={{ height: "38vh", overflowY: "auto" }}>
      {sortRewards(rewards).map((reward: IReward, i: number) => (
        <CartReward
          key={i}
          reward={reward}
          tenantId={tenantId}
          locationId={locationId}
          rewardImageBaseUrl={imageBaseUrl}
          transparentBackground={transparentBackground}
        />
      ))}
    </Col>
  </Row>
);

export default RewardsList;



// WEBPACK FOOTER //
// ./src/screens/RedeemRewards/RedeemConfirmation/RewardsList.tsx